module.exports = "/_next/static/images/2f055c76ba02cb8bcb3d6b74ebca06c2-creditsprd-md.jpg.webp";